import { useParams } from 'react-router-dom';
import { OfferteDetailView } from '../components/offerte-detail/OfferteDetailView';

export function OfferteDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <>
        <div className="flex-1 flex items-center justify-center text-sm text-slate-400">
          Geen offerte-ID opgegeven
        </div>
      </>
    );
  }

  return (
    <>
      <OfferteDetailView offerteId={id} variant="page" />
    </>
  );
}
